import React, {Component} from 'react';
import Card from '../../common/card-grid/Card';
import {
  Button,
  Wrapper,
  Container,
  List,
  Row,
  Item,
  Input,
  selectAll,
  selectNone,
  select,
  isSelected,
  getFilteredData
} from '../../settings/Select';
import {FILTER_NONE, FILTER_ALL} from '../../../constants/filters';
import gql from 'graphql-tag';
import {Query, withApollo} from 'react-apollo';
import NOT_INTERRUPTING_DISFUNCTIONS from '../../../constants/notInterruptingDisfunctions';
import Loading from '../Loading';
import Error from '../Error';

const notInterruptingDisfunctionsSettingsQuery = gql`
  query notInterruptingDisfunctionsSettings($input: SettingsQueryInput!) {
    disfunctions: disfunctionTypes(input: {filter: {isInterrupting: false}}) {
      id
      name
      isInterrupting
    }
    settings(input: $input) {
      id
      notInterruptingDisfunctions {
        type
        ids
      }
    }
  }
`;

class NotInterruptingDisfunctions extends Component {
  state = {
    search: ''
  };

  render() {
    const input = {favoriteId: this.props.favoriteId};
    return (
      <Query query={notInterruptingDisfunctionsSettingsQuery} variables={{input}}>
        {({loading, error, data}) => {
          if (loading)
            return (
              <Card>
                <Loading />
              </Card>
            );
          if (error) return <Error>{error.message}</Error>;
          const filterNotInterruptingDisfunctions = getFilteredData(data.disfunctions, this.state.search);
          return (
            <Card>
              <Wrapper>
                <Button
                  active={data.settings.notInterruptingDisfunctions.type === FILTER_ALL}
                  onClick={() => selectAll(this, data.disfunctions, 'id', 'notInterruptingDisfunctions')}>
                  {NOT_INTERRUPTING_DISFUNCTIONS.find(t => t.key === FILTER_ALL).label}
                </Button>
                <Button
                  active={data.settings.notInterruptingDisfunctions.type === FILTER_NONE}
                  onClick={() => selectNone(this, data.disfunctions, 'id', 'notInterruptingDisfunctions')}>
                  {NOT_INTERRUPTING_DISFUNCTIONS.find(t => t.key === FILTER_NONE).label}
                </Button>
              </Wrapper>
              <Input
                placeholder={'Search notInterruptingDisfunctions'}
                value={this.state.notInterruptingDisfunctions}
                onChange={e => this.setState({search: e.target.value})}
              />
              <Container>
                <List
                  itemCount={filterNotInterruptingDisfunctions.length}
                  renderItem={({index, style}) => (
                    <Row
                      style={style}
                      key={index}
                      onClick={() =>
                        select(
                          this,
                          data.settings.notInterruptingDisfunctions,
                          filterNotInterruptingDisfunctions[index].id,
                          data.disfunctions,
                          'id',
                          'notInterruptingDisfunctions'
                        )
                      }
                      selected={isSelected(
                        data.settings.notInterruptingDisfunctions,
                        filterNotInterruptingDisfunctions[index].id
                      )}>
                      <Item>{filterNotInterruptingDisfunctions[index].name}</Item>
                    </Row>
                  )}
                />
              </Container>
            </Card>
          );
        }}
      </Query>
    );
  }
}

export default withApollo(NotInterruptingDisfunctions);
